import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Client } from 'src/app/shared/models/client.model';

@Injectable({
  providedIn: 'root'
})
export class ClientListService {

  private url: string;

  constructor(private http: HttpClient, public router: Router) {
      this.url = environment.apiUrl;
  }

  /**
   * 
   * @param filter 
   * @param offset 
   * @param limit 
   */
  public resolveClients(filter: string, offset: number, limit: number): Observable<object>
  {
    if (filter === '') {
      return this.getAllClients(offset, limit);
    } else {
      return this.getFilteredClients(filter, offset, limit);
    }
  }

  /**
   *
   */
  public getAllClients(offset: number, limit: number): Observable<object> {
    const params = new HttpParams()
      .append('offset', offset.toString())
      .append('limit' , limit.toString());

    return this.http
               .get(`${this.url}/clients`, { responseType: 'json', params })
               .pipe(
                 catchError(this.errorHandler)
               );
  }

  /**
   * 
   * @param filter 
   * @param offset 
   * @param limit 
   */
  private getFilteredClients(filter: string, offset: number, limit: number): Observable<object> {
    const params = new HttpParams()
      .append('filter', filter)
      .append('offset', offset.toString())
      .append('limit' , limit.toString());

    return this.http
               .get(`${this.url}/clients/search`, { responseType: 'json', params })
               .pipe(
                 catchError(this.errorHandler)
               );
  }

  /**
   *
   * @param client
   */
  create(client: Client) {
    return this.http
               .post(`${this.url}/clients`, client, { responseType: 'json' })
               .pipe(
                catchError(this.errorHandler)
              );
  }

  /**
   *
   * @param client
   */
  update(client: Client) {
    return this.http
               .put(`${this.url}/clients`, client, { responseType: 'json' })
               .pipe(
                catchError(this.errorHandler)
              );
  }

  /**
   *
   * @param id
   */
  delete(id: number) {
    return this.http
               .delete(`${this.url}/clients/${id}`, { responseType: 'json' })
               .pipe(
                catchError(this.errorHandler)
              );
  }

  /**
   *
   * @param error
   */
  private errorHandler(error: HttpErrorResponse) {
    return throwError(error);
  }
}
